/**
 * @file Lazily loads VueAxe to check for accessibility issues
 */
import environment from 'bits/environment'
import type { VueAxeOptions, VueAxePlugin } from 'vue-axe'

export function getVueAxe(): Promise<VueAxePlugin | undefined> {
  return new Promise((resolve) => {
    if (environment === 'development') {
      import('vue-axe').then((vueAxe) => {
        resolve(vueAxe.default)
      })
    } else {
      resolve(undefined)
    }
  })
}

export function getVueAxeOptions(): VueAxeOptions {
  return {
    allowConsoleClears: false,
    clearConsoleOnUpdate: false,
  }
}
